class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/notification-settings`;
    }
    /**
     * Returns notification settings for the current extension.
     *
     * Knowledge Article: [User Settings - Set Up Message Notifications](https://success.ringcentral.com/articles/RC_Knowledge_Article/9740)
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/notification-settings
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadMessagesNotificationsSettings
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates notification settings for the current extension.
     * Knowledge Article: [User Settings - Set Up Message Notifications](https://success.ringcentral.com/articles/RC_Knowledge_Article/9740)
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/notification-settings
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditMessagesNotificationsSettings
     */
    async put(notificationSettingsUpdateRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), notificationSettingsUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
